import { Product } from 'common/accounting/AccountingDocuments';
import { CoreInstanceType } from 'common/core/CoreInstanceConstants';

export const coreInstanceType2ProductID = (coreInstanceTypeID: CoreInstanceType) => {
  if (coreInstanceTypeID == CoreInstanceType.XSMALL) return Product.INSTANCE_XSMALL;
  if (coreInstanceTypeID == CoreInstanceType.SMALL) return Product.INSTANCE_SMALL;
  if (coreInstanceTypeID == CoreInstanceType.MEDIUM) return Product.INSTANCE_MEDIUM;
  if (coreInstanceTypeID == CoreInstanceType.LARGE) return Product.INSTANCE_LARGE;
  if (coreInstanceTypeID == CoreInstanceType.XLARGE) return Product.INSTANCE_XLARGE;
  return null;
};

export const averageDaysInMonth = 365.25 / 12;
export const averageWorkingDaysInMonth = 21;
export const averageWorkingHoursInDay = 7;

export const priceMonthlyToPerSecond = (monthlyPrice: number) => {
  const hoursInDay = 24;
  const minutesInHour = 60;
  const secondsInMinute = 60;
  const secondsInMonth = averageDaysInMonth * hoursInDay * minutesInHour * secondsInMinute;
  return monthlyPrice / secondsInMonth;
};

export const priceMonthlyToPerHour = (monthlyPrice: number) => {
  const hoursInDay = 24;
  const hoursInMonth = averageDaysInMonth * hoursInDay;
  return monthlyPrice / hoursInMonth;
};

export const priceListPerMonth = {
  deployment: 14.6, // (0.02/hour) Last Updated 4.1.2024
  storagePerGiB: 0.18,
  coreInstancePrice: {
    [CoreInstanceType.XSMALL]: 12.64, // Last Updated from Diploi Business Case Doc 10.11.2023
    [CoreInstanceType.SMALL]: 18.98,
    [CoreInstanceType.MEDIUM]: 34.71,
    [CoreInstanceType.LARGE]: 65.07,
    [CoreInstanceType.XLARGE]: 132.67,
  } as { [key in CoreInstanceType]: number },
};

export const priceListPerHour = {
  deployment: priceMonthlyToPerHour(priceListPerMonth.deployment),
  storagePerGiB: priceMonthlyToPerHour(priceListPerMonth.storagePerGiB),
  coreInstancePrice: {
    [CoreInstanceType.XSMALL]: priceMonthlyToPerHour(priceListPerMonth.coreInstancePrice[CoreInstanceType.XSMALL]),
    [CoreInstanceType.SMALL]: priceMonthlyToPerHour(priceListPerMonth.coreInstancePrice[CoreInstanceType.SMALL]),
    [CoreInstanceType.MEDIUM]: priceMonthlyToPerHour(priceListPerMonth.coreInstancePrice[CoreInstanceType.MEDIUM]),
    [CoreInstanceType.LARGE]: priceMonthlyToPerHour(priceListPerMonth.coreInstancePrice[CoreInstanceType.LARGE]),
    [CoreInstanceType.XLARGE]: priceMonthlyToPerHour(priceListPerMonth.coreInstancePrice[CoreInstanceType.XLARGE]),
  } as { [key in CoreInstanceType]: number },
};

export const priceListPerSecond = {
  deployment: priceMonthlyToPerSecond(priceListPerMonth.deployment),
  storagePerGiB: priceMonthlyToPerSecond(priceListPerMonth.storagePerGiB),
  coreInstancePrice: {
    [CoreInstanceType.XSMALL]: priceMonthlyToPerSecond(priceListPerMonth.coreInstancePrice[CoreInstanceType.XSMALL]),
    [CoreInstanceType.SMALL]: priceMonthlyToPerSecond(priceListPerMonth.coreInstancePrice[CoreInstanceType.SMALL]),
    [CoreInstanceType.MEDIUM]: priceMonthlyToPerSecond(priceListPerMonth.coreInstancePrice[CoreInstanceType.MEDIUM]),
    [CoreInstanceType.LARGE]: priceMonthlyToPerSecond(priceListPerMonth.coreInstancePrice[CoreInstanceType.LARGE]),
    [CoreInstanceType.XLARGE]: priceMonthlyToPerSecond(priceListPerMonth.coreInstancePrice[CoreInstanceType.XLARGE]),
  } as { [key in CoreInstanceType]: number },
};
